import { render, staticRenderFns } from "./v-text-switch.vue?vue&type=template&id=90724812&scoped=true&"
import script from "./v-text-switch.vue?vue&type=script&lang=js&"
export * from "./v-text-switch.vue?vue&type=script&lang=js&"
import style0 from "./v-text-switch.vue?vue&type=style&index=0&id=90724812&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90724812",
  null
  
)

export default component.exports